
import * as layerNames from '@/services/layerName';
import layerManager from '@/services/layer.manager';
import { URLService } from '@/services/url.service';
import utils from '@/utils/util';

function buildIMHref (href) {
  let urlSerivce = new URLService(href);
  urlSerivce.queryParams.replace('sourceId', '16003');
  return urlSerivce.build();
}
const imComfirm = {
  layerName: layerNames.HOME_CONFIRM,
  pvTrackClick: 'ZNZT-vrdk-app_ziyuanwei_im_click',
  pvTrackShow: 'ZNZT-vrdk-app_ziyuanwei_im_show',
  showCancel: false,
  showCloseIcon: true,
  showDlrMiddlePopupIcon: true,
  title: '当前暂无顾问可接待',
  content: '您可点击“在线咨询”，顾问上线后将第一时间与您沟通',
  okText: '在线咨询',
};
const xunjiaComfirm = {
  layerName: layerNames.HOME_CONFIRM,
  pvTrackClick: 'ZNZT-vrdk-app_ziyuanwei_xunjia_click',
  pvTrackShow: 'ZNZT-vrdk-app_ziyuanwei_xunjia_show',
  showCancel: false,
  showCloseIcon: true,
  showDlrMiddlePopupIcon: true,
  title: '当前暂无顾问可接待',
  content: '您可先向顾问询价，顾问上线后将第一时间与您沟通',
  okText: '向顾问询价',
  onOk: function () {
    layerManager.price(0, 0, '2022040801');
  }
};

export function vrConfrimParam (hasIM, imInfo) {
  if (hasIM) {
    imComfirm.onOk = function () {
      if (hasIM) {
        let href = '';
        if (utils.browser.isApp) {
          href = imInfo.displayAdviser.appChatScheme;
        } else {
          href = imInfo.displayAdviser.linkUrl;
        }
        const imUrl = buildIMHref(href);
        window.location = imUrl;
      }
    };
    return imComfirm;
  } else {
    return xunjiaComfirm;
  }
};
